import { MapPin, Navigation, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
export default function OurLocation() {
  return <section data-section-id="224256" id="our-service-area" className="relative w-full h-[600px] bg-background text-foreground border-y border-primary overflow-hidden">
      {}
      <div className="absolute inset-0 w-full h-full bg-primary/20">
        <iframe title="Peace River Pest Control Service Area Map" src="https://maps.google.com/maps?q=Punta%20Gorda,%20FL&t=&z=10&ie=UTF8&iwloc=&output=embed" width="100%" height="100%" style={{
        border: 0
      }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="w-full h-full grayscale contrast-150 opacity-70 dark:opacity-50 pointer-events-auto" />
        {}
        <div className="absolute inset-0 pointer-events-none bg-gradient-to-r from-background/90 via-background/40 to-transparent md:w-1/2" />
      </div>

      {}
      <div className="absolute inset-x-4 bottom-6 md:inset-auto md:top-1/2 md:left-16 md:-translate-y-1/2 md:w-[400px] z-10">
        <Card className="shadow-none border-2 border-primary bg-card/95 backdrop-blur-sm">
          <CardHeader className="pb-4">
            <CardTitle className="font-default text-3xl flex items-center gap-2 text-foreground uppercase tracking-tight">
              <MapPin className="size-6 text-foreground" />
              Service Area
            </CardTitle>
            <CardDescription className="text-lg text-foreground font-serif leading-relaxed">
              Providing elite pest protection across Punta Gorda, Cape Coral, Port Charlotte, and North Fort Myers.
            </CardDescription>
          </CardHeader>
          <CardContent className="grid gap-5 pb-6">
            <div className="flex items-start gap-4 p-3 bg-background border-2 border-primary">
              <MapPin className="size-5 text-foreground shrink-0 mt-0.5" />
              <div className="flex flex-col">
                <span className="font-default font-bold text-foreground text-xs uppercase tracking-widest mb-1">
                  Headquarters
                </span>
                <span className="font-serif text-foreground text-xl">
                  Punta Gorda, FL
                </span>
              </div>
            </div>
            <div className="flex items-start gap-4 p-3 bg-background border-2 border-primary">
              <Phone className="size-5 text-foreground shrink-0 mt-0.5" />
              <div className="flex flex-col">
                <span className="font-default font-bold text-foreground text-xs uppercase tracking-widest mb-1">
                  Dispatch Line
                </span>
                <span className="font-serif text-foreground text-xl">Call for Inspection</span>
              </div>
            </div>
          </CardContent>
          <CardFooter>
            <Button asChild className="w-full font-default font-bold uppercase tracking-widest h-14 text-lg rounded-full bg-primary text-primary-foreground hover:scale-105 transition-transform">
              <Link to="/ContactPage">
                <Navigation className="size-5 mr-2" />
                Get A Free Quote
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}